import React, { useEffect, useState } from 'react';

import { Flexbox, FontAwesomeIcon } from '@schoolinks/ui-components';

import cn from 'classnames';
import { string, bool } from 'prop-types';

import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';

import s from './Placeholder.css';

const Placeholder = ({ width, height, isLoadingCredential }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isLoadingCredential) {
      setIsVisible(true);
    }
  }, [isLoadingCredential]);

  return (
    <Flexbox
      alignItems="center"
      className={cn(s.placeholder, { [s.visible]: isVisible })}
      height={height}
      justifyContent="center"
      width={width}
    >
      <FontAwesomeIcon color="grayDark" icon={faFileCertificate} />
    </Flexbox>
  );
};

Placeholder.propTypes = {
  width: string,
  height: string,
  isLoadingCredential: bool,
};

Placeholder.defaultProps = {
  width: '100%',
  height: '100%',
  isLoadingCredential: true,
};

export default Placeholder;
